import React from 'react';
import PropTypes from 'prop-types';
import TextBox from '../TextBox';
import { isWebsite } from '../../utils/validations';
import { errors } from '../../constants';

const WebsiteField = ({ testId, label, name, placeholder, disabled, readOnly, isRequired, value, onValueChanged, showClearButton, maxLength }) => {
  const isWebsiteValid = isWebsite(value);

  return (
    <TextBox
      testId={testId}
      label={label}
      placeholder={placeholder}
      name={name}
      readOnly={readOnly}
      showClearButton={showClearButton}
      disabled={disabled}
      isRequired={isRequired}
      isValid={isWebsiteValid}
      errorText={!isWebsiteValid && errors.INVALID_URL}
      value={value}
      maxLength={maxLength}
      onValueChanged={onValueChanged} />
  );
};

WebsiteField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  showClearButton: PropTypes.bool,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  onValueChanged: PropTypes.func,
  testId: PropTypes.string
};

WebsiteField.defaultProps = {
  name: 'website',
  maxLength: 300
};

export default WebsiteField;
